import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const PromotionCoupon = React.lazy(() =>
    import('../PromotionCoupon')
);
const promotionCouponRoutesRegistry = [
    {
        path: PAGE_URL.PROMOTION_COUPON_PAGE,
        element: <PromotionCoupon />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default promotionCouponRoutesRegistry;
